import EVENT_REGISTRY from "../constants/registryConstants";

/**
 * Event Registry Configuration
 * Defines which events should be sent to which analytics services
 *
 * Available services: "postHog"
 *
 * Usage:
 * - Add your event name as a key
 * - Set the value as an array of service names where the event should be sent
 * - If you want an event to go to all services, use ["postHog"]
 * - If you want an event to go to only specific services, list only those services
 */

/**
 * Get the list of services for a specific event
 * @param {string} eventName - Name of the event
 * @returns {Array} Array of service names where the event should be sent
 */
export const getEventServices = (eventName) => {
	return EVENT_REGISTRY[eventName] || [];
};

/**
 * Check if an event should be sent to a specific service
 * @param {string} eventName - Name of the event
 * @param {string} serviceName - Name of the service to check
 * @returns {boolean} True if event should be sent to the service
 */
export const shouldSendToService = (eventName, serviceName) => {
	const services = getEventServices(eventName);
	return services.includes(serviceName);
};
